export default __webpack_public_path__ + "static/media/ruslan.ef13645f.jp2";